module.exports = __webpack_public_path__ + "img/icon_dpi_active.50cb238f.svg";